export interface Menu {
  icon?: string;
  title?: string;
  path: string;
  children?: Menu[];
  opened?: boolean;
}
